import React from "react";
import {useStakingContract, useStakingDispatch} from "../../context/StakingContract";
import {SET_APPROVE_TX_HASH, SET_ERROR_WITH_MESSAGE, SET_PREAUTH_LOADING} from "../../context/StakingContract/actions";

const PreAuthorization = ({ nextStep, lastStep, previousStep }) => {
  const {stakingContract, state} = useStakingContract();
  const dispatch = useStakingDispatch();

  const onClick = () => {
    const {allowance} = state;
    stakingContract.approveContract(allowance.toApprove.toString())
      .then(v => {
        dispatch({type: SET_APPROVE_TX_HASH, payload: v.hash});
        dispatch({type: SET_PREAUTH_LOADING, payload: true});
        stakingContract.provider.waitForTransaction(v.hash).then(tx => {
          if ( tx.status ) {
            dispatch({type: SET_PREAUTH_LOADING, payload: false});
            nextStep();
          } else {
            dispatch({type: SET_PREAUTH_LOADING, payload: false});
            dispatch({type: SET_ERROR_WITH_MESSAGE, payload: "Something went wrong with your approval, try again if you wish to stake."});
            lastStep();
          }
        }).catch(err => {
          console.warn(err);
          dispatch({type: SET_ERROR_WITH_MESSAGE, payload: "Something went wrong with your approval, try again if you wish to stake."});
          lastStep();
        });
      }).catch(err => {
        console.warn(err);
        dispatch({type: SET_ERROR_WITH_MESSAGE, payload: "Something went wrong with your approval, try again if you wish to stake."});
        lastStep();
    });
  };

  const {allowance, ui} = state;
  return (
    <div className={ui.preAuth.loading ? 'card waiting' : 'card'}>
      <div className="card-body">
        <div className="content">
          <h3>Pre-authorization</h3>
          <p className="lead">1<sup>st</sup> of 2 transactions required.</p>
          <p>First transaction is the <strong>Pre-authorization</strong> step, where you allow the pre-staking contract to access your tokens upto the provided amount:</p>
          <p className="mb-4"><strong>{allowance.toApprove.toLocaleString('en')} ERD</strong> - You will be asked to confirm that you allow the smart contract to have access to {allowance.toApprove.toLocaleString('en')} ERD from your wallet.
            <br/>
            <small className="text-muted"><sup>*</sup> Make sure you have enough ETH to pay for transaction fees.</small>
          </p>
          <button className="btn btn-primary" onClick={onClick}>
            Approve
          </button>
          <button className="btn btn-link" onClick={previousStep}>Change amount</button>
        </div>
        <div className="spinner align-items-center">
          <div className="mx-auto text-center">
            <div className="col-12 text-center">
              <div className="lds-ellipsis mx-auto">
                <div />
                <div />
                <div />
                <div />
              </div>
            </div>
            <p>
              <span className="font-weight-bold">Waiting for the transaction to complete</span><br/>
              Please wait for the Metamask transaction to complete before any other action.</p>
            {
              allowance.approveTxHash && (
                <p><a href={"https://etherscan.io/tx/" + allowance.approveTxHash} target="_blank">{allowance.approveTxHash}</a></p>
              )
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreAuthorization;
